// Tiny spring integrator for per-frame toys (no React). Semi-implicit Euler, dt clamped
// so a backgrounded tab returning with a huge dt can't explode the state.
export type Spring = { x: number; v: number };
export type SpringPreset = { stiffness: number; damping: number };

export const PRESETS = {
  snappy: { stiffness: 520, damping: 42 },
  bouncy: { stiffness: 260, damping: 14 },
  lazy: { stiffness: 60, damping: 14 },
} as const satisfies Record<string, SpringPreset>;

const MAX_DT = 1 / 30;

export function stepSpring(s: Spring, target: number, dt: number, p: SpringPreset): Spring {
  if (s.x === target && s.v === 0) return s;
  const h = Math.min(Math.max(dt, 0), MAX_DT);
  const a = -p.stiffness * (s.x - target) - p.damping * s.v;
  const v = s.v + a * h;
  return { x: s.x + v * h, v };
}

export function settled(s: Spring, target: number, eps = 0.01): boolean {
  return Math.abs(s.x - target) < eps && Math.abs(s.v) < eps;
}
